import { render } from "./DrawerChat.vue?vue&type=template&id=dc6387d0&ts=true"
import script from "./DrawerChat.vue?vue&type=script&lang=ts"
export * from "./DrawerChat.vue?vue&type=script&lang=ts"

import "./DrawerChat.vue?vue&type=style&index=0&id=dc6387d0&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__